module.exports = "<div class=nav-container><ul><li ng-repeat=\"item in adminNavigationCtrl.menuItems\" ui-sref={{::item.state}} ui-sref-active=active>{{::item.name}}</li></ul></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-navigation/admin-navigation.html
// module id = 655
// module chunks = 0